import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Scissors, CheckCircle2, Loader2 } from 'lucide-react';
export function LeadMagnet() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail('');
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };
  return <section className="py-20 bg-brand-gray border-y border-gray-200" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-147">
          {/* Left: Coupon Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="relative max-w-md mx-auto lg:mx-0 w-full" data-id="element-148">
            {/* Scissor icon decorative */}
            <div className="absolute -top-4 -left-4 text-gray-400 z-10 bg-brand-gray p-1" data-id="element-149">
              <Scissors className="w-6 h-6" data-id="element-150" />
            </div>

            <div className="bg-white border-4 border-dashed border-brand-red rounded-lg p-8 text-center shadow-lg relative overflow-hidden" data-id="element-151">
              {/* Corner ribbon */}
              <div className="absolute top-4 -right-12 bg-brand-navy text-white text-xs font-bold uppercase py-1 px-12 rotate-45 shadow-sm" data-id="element-152">
                Expires Soon
              </div>

              <h3 className="text-6xl font-display font-bold text-brand-red leading-none mb-2" data-id="element-153">
                SAVE $50
              </h3>
              <p className="text-xl font-display font-bold text-brand-navy uppercase tracking-wide mb-6" data-id="element-154">
                Off Your First Service Call
              </p>

              <div className="w-16 h-1 bg-gray-200 mx-auto mb-6" data-id="element-155"></div>

              <p className="text-xs text-gray-500 uppercase tracking-wider leading-relaxed" data-id="element-156">
                New customers only. Not valid with other offers. <br data-id="element-157" />
                Mention code when booking.
              </p>
            </div>
          </motion.div>

          {/* Right: Opt-in Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-center lg:text-left" data-id="element-158">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-navy uppercase mb-4" data-id="element-159">
              Claim Your $50 Off Coupon
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-160">
              Drop your email and we will send your coupon code instantly. Plus,
              get our free Plumbing Maintenance Checklist to keep your pipes
              flowing smoothly.
            </p>

            {isSuccess ? <div className="bg-green-50 border border-green-200 rounded-md p-6 flex items-center gap-4" data-id="element-161">
                <CheckCircle2 className="w-8 h-8 text-green-600 shrink-0" data-id="element-162" />
                <div className="text-left" data-id="element-163">
                  <p className="font-bold text-green-800 uppercase" data-id="element-164">
                    Coupon Sent!
                  </p>
                  <p className="text-green-700 text-sm" data-id="element-165">
                    Check your inbox for your $50 off code and checklist.
                  </p>
                </div>
              </div> : <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto lg:mx-0" data-id="element-166">
                <label htmlFor="coupon-email" className="sr-only" data-id="element-167">
                  Email Address
                </label>
                <input type="email" id="coupon-email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email address" className="flex-grow px-4 py-4 rounded-md border border-gray-300 focus:ring-2 focus:ring-brand-red focus:border-brand-red outline-none transition-all" data-id="element-168" />
                <button type="submit" disabled={isSubmitting} className="bg-brand-red hover:bg-brand-redDark text-white font-bold px-8 py-4 rounded-md uppercase tracking-wide transition-colors flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-70" data-id="element-169">
                  {isSubmitting ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-170" /> : 'Send Me The Coupon'}
                </button>
              </form>}

            <p className="text-xs text-gray-500 mt-4" data-id="element-171">
              No spam. Unsubscribe anytime.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}